<template>
  <div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-documento-update
      block
      :disabled="!disabled"
      variant="relief-primary"
      class="btn-icon"
    >
      <feather-icon icon="EditIcon" />
      <!-- Editar -->
    </b-button>

    <b-modal
      id="modal-documento-update"
      ok-title="guardar datos"
      ok-variant="relief-success"
      cancel-title="cancelar"
      cancel-variant="relief-danger"
      centered
      size="xl"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Actualuizar Documentos"
      @ok="validationForm"
      @cancel="resetValues"
      @close="resetValues"
    >

      <b-row>
        <b-col cols="12">
          <b-alert
            :show="status"
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertTriangleIcon"
              />
              <span
                class="ml-25"
              >Por favor, verifica que los datos son correctos.
              </span>
            </div>
          </b-alert>
        </b-col>
        <b-col xl="1">
          <center>
            <h5>Ver </h5>
          </center>
        </b-col>
        <b-col xl="3">
          <h5>Nombre del Archivo</h5>
        </b-col>
        <b-col xl="4">
          <h5>Tipo de Documento</h5>
        </b-col>
        <b-col xl="4">
          <h5>Subir un Nuevo Documento</h5>
        </b-col>
      </b-row>
      <hr>
      <validation-observer ref="formDocumentosUpdate">
        <div v-if="documentosList.length > 0">
          <b-row
            v-for="(doc) in newDocumets"
            :key="doc.id"
            class="mb-1"
          >
            <b-col xl="1"
              class="mb-1"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-75 btn-icon"
                size="md"
                block
                @click="showDocument(doc.url)"
              >
                <feather-icon icon="FileTextIcon" />
                <!-- <small>Ver Documento</small> -->
              </b-button>
            </b-col>
            <b-col xl="3">
              <h6 class="mb-0">

                {{ uploadName(doc.url) }}
                <!-- {{ doc }} -->
                <!-- {{ doc.nombre }} -->
                <!-- <feather-icon
                  v-if="doc.tipoDocumentoId !== doc.axuId "
                  icon="CheckIcon"
                /> -->
              </h6>
              <!-- <small>{{ uploadName(doc.url) }}</small> -->
            </b-col>
            <!-- <b-col cols="3">{{ uploadName(doc.url) }}</b-col> -->
            <b-col xl="4">
              <b-form>
                <validation-provider
                  #default="{ errors }"
                  name="Tipo Documento"
                  rules="required"
                >
                  <b-form-group>
                    <v-select
                      v-model="doc.tipoDocumentoId"
                      :id="`select-doc-${doc.id}`"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="documentosList"
                      :reduce="documento => documento.id"
                      placeholder="selecciona una opción"
                      value="value"
                      label="nombre"
                    >
                      <template slot="no-options">
                        No hay datos para mostrar.
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-form>
            </b-col>
            <b-col xl="4">
              <b-form-file
                v-model="doc.documento"
                :id="`input-file-${doc.id}`"
                browse-text="Buscar"
                :disabled="!doc.url"
                :placeholder="getName(doc)"
              />
            </b-col>
          </b-row>
        </div>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert,
  BButton,
  BCol,
  BFormGroup,
  BForm,
  BFormFile,
  BModal,
  VBModal,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import CatalogosService from '@/services/CatalogosService'
import PrebecarioService from '@/services/PrebecariosService'

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BAlert,
    BButton,
    BCol,
    BFormGroup,
    BForm,
    BFormFile,
    BModal,
    BRow,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    current: {
      type: [Array, Object],
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    convocatoriaId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      catDocumentos: [],
      newDocumets: [],
      documentosList: [],
      status: false,
    }
  },
  computed: {
    uploadName() {
      return url => {
        const array = url.split('/')
        const n = array.length
        return array[n - 1]
      }
    },
    getName() {
      return doc => {
        if (!doc.tipoDocumentoId) return 'Subir Archivo ...'
        const { nombre } = this.documentosList.find(e => e.id === doc.tipoDocumentoId)
        return `Subir ${nombre}`
      }
    },
  },
  mounted() {
    this.fetchCatDocumentosConvocatoria()
    this.createNewDocuments()
  },
  methods: {
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    createNewDocuments() {
      this.newDocumets = []
      this.current.forEach(element => {
        const { id, documento, tipo_documento: tipoDocumento } = element
        const { id: tipoDocumentoId, nombre } = tipoDocumento
        const document = {
          id,
          url: documento,
          tipoDocumentoId,
          nombre,
          status: false,
          axuId: tipoDocumentoId,
          documento: null,
        }
        this.newDocumets.push(document)
      })
    },
    validationForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.formDocumentosUpdate.validate().then(success => {
        if (success) {
          this.status = false
          this.newDocumets.forEach(async e => {
            if (e.documento || e.axuId !== e.tipoDocumentoId) {
              const form = new FormData()
              if (e.documento) {
                form.append('documento', e.documento)
              }
              if (e.axuId !== e.tipoDocumentoId) {
                form.append('tipo_documento_id', e.tipoDocumentoId)
              }
              await this.saveDocument(e.id, form)
            }
          })
          this.msg({
            title: 'OK!',
            text: 'Los documentos seactualizaron correctamente!',
            icon: 'success',
          })
          this.$bvModal.hide('modal-documento-update')
        } else {
          this.status = true
        }
      })
    },
    saveDocument(id, formData) {
      PrebecarioService.updateDocumentValid(id, formData)
        .then(resp => {
          if (resp.status === 200) {
            this.$emit('update', resp.data)
            // this.createNewDocuments()
            // this.emit('update', {
            //   type: 2,
            //   data: resp.data,
            // })
            // this.$bvModal.hide('modal-estudios')
            // const nivelEstudios = this.catNivelEstudios.find(element => element.id === resp.data.nivel_estudios)
            // const tipoComprobante = this.catComprobanteEstudios.find(element => element.id === resp.data.tipo_comprobante)
            // this.$emit('update', { nivelEstudios, tipoComprobante })
            // this.msg({
            //   title: 'OK!',
            //   text: 'Datos actualizados correctamente!',
            //   icon: 'success',
            // })
          }
        })
        .catch(() => {
          this.msg({
            title: 'Error!',
            text: 'Lo sentimos algo salio mal!',
            icon: 'error',
          })
        })
    },
    showDocument(url) {
      window.open(url, '_blank', 'width=600,height=800')
    },
    resetValues() {
      this.status = false
      this.fetchCatDocumentosConvocatoria()
      this.createNewDocuments()
    },
    fetchCatDocumentosConvocatoria() {
      CatalogosService.getCatPubConvocatoriaDocumento({
        convocatoria: this.convocatoriaId,
        // convocatoria: 16,
      }).then(resp => {
        this.catDocumentos = []
        this.documentosList = []
        this.catDocumentos = resp.data
        this.catDocumentos.forEach(element => {
          const { nombre, id } = element.documento
          const doc = { id, nombre }
          this.documentosList.push(doc)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

pre {
  min-height: 295px;
  padding: 1.5rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
}
</style>
